import moment from 'moment'
import 'moment-timezone'
import axios from 'axios'
import { createApp, configureCompat } from 'vue'
import VueFormGenerator from 'vue-form-generator'
import checkboxTextField from './custom/CheckTextField'
import collapseOptionsField from './custom/CollapseOptionsField'
import inputUnitField from './custom/InputUnit'
import typeaheadSelect from './custom/TypeaheadSelect'
import ToggleButton from './ui/ToggleButton.vue'
import Trend from './ui/Trend.vue'
import * as Sentry from '@sentry/vue'

import './assets/style/tailwind.css'
import 'cal-heatmap/cal-heatmap.css'
import ui from './ui'

import router from './modules/router'
import i18n from './i18n'
import store, { SESSION_EXPIRED } from './_store'

import App from './App'

configureCompat({
  MODE: 2,
  FILTERS: true,
  COMPONENT_V_MODEL: true,
  RENDER_FUNCTION: true,
  INSTANCE_LISTENERS: true,
  INSTANCE_ATTRS_CLASS_STYLE: true,
  INSTANCE_EVENT_EMITTER: false,
  ATTR_FALSE_VALUE: true,
  GLOBAL_PROTOTYPE: true
})

moment.tz.setDefault('UTC')

const app = createApp(App)

const pageName = window.location.pathname.replace(/\/$/, '').split('/').pop()
const capabilityPage = ['reset-password', 'open'].includes(pageName)
if (!capabilityPage) {
  Sentry.init({
    app,
    dsn: 'https://glet_55bf90dacfc4be92d3acf23316e0f441@observe.gitlab.com:443/errortracking/api/v1/projects/2707621'
  })
}

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response && error.response.status
    const skipRedirect = error && error.config && error.config.skipAuthRedirect
    if (status === 401 && store.getters.isAuthenticated && !skipRedirect) {
      store.commit(SESSION_EXPIRED)
      if (router.currentRoute.value.path !== '/login') {
        router.replace('/login')
      }
    }
    return Promise.reject(error)
  }
)

app.use(store)
app.use(router)
app.use(i18n)
app.use(ui)
app.use(VueFormGenerator)

app.component('ToggleButton', ToggleButton)
app.component('toggle-button', ToggleButton)
app.component('Trend', Trend)
app.component('trend', Trend)

app.component('fieldCheckboxText', checkboxTextField)
app.component('fieldCollapseOptions', collapseOptionsField)
app.component('fieldInputUnit', inputUnitField)
app.component('fieldTypeaheadSelect', typeaheadSelect)

app.mixin({
  filters: {
    round (num, precision = 0) {
      const n = Number(num)
      if (Number.isNaN(n)) return num
      const p = Math.pow(10, precision)
      return Math.round(n * p) / p
    },
    number (num) {
      const n = Number(num)
      if (Number.isNaN(n)) return num
      return n.toLocaleString('cs')
    }
  }
})

app.mount('#app')
